module.exports = __webpack_public_path__ + "assets/images/chart-outline.e21ac1fcf41e359d8b7adf4f0673e61f.svg";